// extracted by css-extract-rspack-plugin
export default {"clamp":"ReadMoreReadLess__clamp--A_qc5","collapse":"ReadMoreReadLess__collapse--kNDu6","btnarea":"ReadMoreReadLess__btnarea--M2kXl"};